// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const MENU_TYPE = '@customization/MENU_TYPE';
export const ADD_CAMERA = 'ADD_CAMERA';
export const IS_ANNOTATION = 'IS_ANNOTATION';
export const CHECK_IMAGE = 'CHECK_IMAGE';
export const CAMERA_DATA = 'CAMERA_DATA';
export const ZONE_DATA = 'ZONE_DATA';
export const SELECTED_CAMERA = 'SELECTED_CAMERA';
export const NEW_ZONES = 'NEW_ZONES';
export const SHOW_ZONE_INPUT = 'SHOW_ZONE_INPUT';
export const POLYGON_DETAILS = 'POLYGON_DETAILS';
export const SAVED_POLYGONS = 'SAVED_POLYGONS';
export const CURRENT_DATE = 'CURRENT_DATE';
export const SET_SELECTED_ZONES = 'SET_SELECTED_ZONES';
export const SELECTED_TIME = 'SELECTED_TIME';
export const VIDEO_PLAYING = 'VIDEO_PLAYING';
export const SIDEBAR_STATE = 'SIDEBAR_STATE';
